export default __webpack_public_path__ + "static/media/Moong.8335b622.jpg";